export const goldenSettingsTreeModalWidth = '700px';
export const goldenSettingsCheckboxTreeModalWidth = '700px';
export const goldenSettingsTModalHeight = '80vh';
export const importGoldenSettingsModalWidth = '500px';
export const treeWrapperKey = 'ENB';
export const responsePathSeparator = '/';
export const iconColorProps = { color: 'currentColor' };
